import axiosInstance from "../helpers/axios";

// Filter interface for orders
export interface OrderFilters {
    sortBy?: string;
    sortOrder?: "asc" | "desc";
    page?: number;
    limit?: number;
    search?: string;
    orderStatusId?: string;
    minPrice?: number;
    maxPrice?: number;
    startDate?: string;
    endDate?: string;
}

// Get all non-shipped orders
export const allOrdersApi = async (filters?: OrderFilters) => {
    try {
        const params = new URLSearchParams();

        if (filters?.sortBy) params.append("sortBy", filters.sortBy);
        if (filters?.sortOrder) params.append("sortOrder", filters.sortOrder);
        if (filters?.page) params.append("page", filters.page.toString());
        if (filters?.limit) params.append("limit", filters.limit.toString());
        if (filters?.search) params.append("search", filters.search);
        if (filters?.orderStatusId !== undefined) params.append("orderStatusId", filters.orderStatusId);
        if (filters?.minPrice !== undefined) params.append("minPrice", String(filters.minPrice));
        if (filters?.maxPrice !== undefined) params.append("maxPrice", String(filters.maxPrice));
        if (filters?.startDate) params.append("startDate", filters.startDate);
        if (filters?.endDate) params.append("endDate", filters.endDate);

        const queryString = params.toString();
        const url = `/orders/getNonShippedOrders${queryString ? `?${queryString}` : ""}`;

        const { data } = await axiosInstance.get(url);
        return data;
    } catch (error) {
        console.error("Error fetching orders:", error);
        return null;
    }
};

// Get individual order details
export const individualOrderApi = async () => {
    try {
        const { data } = await axiosInstance.get("/orders/getIndividualOrder");
        return data;
    } catch (error) {
        console.error("Error fetching individual order:", error);
        return null;
    }
};

// Get shipped orders
export const shippedOrderApi = async (filters?: OrderFilters) => {
    try {
        const params = new URLSearchParams();

        if (filters?.sortBy) params.append("sortBy", filters.sortBy);
        if (filters?.sortOrder) params.append("sortOrder", filters.sortOrder);
        if (filters?.page) params.append("page", filters.page.toString());
        if (filters?.limit) params.append("limit", filters.limit.toString());
        if (filters?.search) params.append("search", filters.search);
        if (filters?.minPrice !== undefined) params.append("minPrice", filters.minPrice.toString());
        if (filters?.maxPrice !== undefined) params.append("maxPrice", filters.maxPrice.toString());
        if (filters?.startDate) params.append("startDate", filters.startDate);
        if (filters?.endDate) params.append("endDate", filters.endDate);

        const queryString = params.toString();
        const url = `/orders/getShippingOrders${queryString ? `?${queryString}` : ""}`;

        const { data } = await axiosInstance.get(url);
        return data;
    } catch (error) {
        console.error("Error fetching shipped orders:", error);
        return null;
    }
};

// Get order by ID
export const getOrdersById = async (orderObj: { userId: any; orderId: number }) => {
    try {
        const { data } = await axiosInstance.put("/orders/orderById", orderObj);
        return data;
    } catch (error) {
        console.error("Error fetching order by ID:", error);
        return null;
    }
};

// Update order status
export const updateOrderStatus = async (orderObj: Record<string, any>) => {
    try {
        const { data } = await axiosInstance.put("/orders/updateOrder", orderObj);
        return data;
    } catch (error) {
        console.error("Error updating order status:", error);
        return null;
    }
};